import { createSelector } from 'reselect';
import { WebInterfaceBaseState } from 'common/base/state';

const getPanelStatus = (state: WebInterfaceBaseState, panelId: string): boolean => {
	const panel = state.layouts.contentLayout.entities.panels.get(panelId);
	if (!panel) {
		return false;
	}
	return panel.isActive;
};

const getPanelActiveStatus = createSelector([getPanelStatus], (status: boolean): boolean => status);

export { getPanelActiveStatus };
